import React from 'react';
import tapIcon from "../../services/TapIcon";
import Ax from "../../components/hoc/Ax";

export default  (props) => <Ax><tapIcon.FontAwesomeIcon icon={tapIcon.faCircle} color={props.color} className="mx-1" /><span>{props.children}</span></Ax>;